export const ENTERPRISE_LOGIN_LOGOUT_PATH = 'logout';

export const getEnterpriseLoginLogoutPath = () => `/${ENTERPRISE_LOGIN_LOGOUT_PATH}`;
